import { LegalLayout } from "@/components/site/LegalLayout";

export default function RefundPage() {
  return (
    <LegalLayout
      title="Refund and Withdrawal Policy"
      lastUpdated="August 3, 2026"
      path="/refund-policy"
      metaTitle="Refund &amp; Withdrawal Policy"
      metaDescription="Refund, withdrawal, and wallet balance procedures for DC Dashboard operated by Danny Clans Media Limited — including processing times, fees, and fraud reviews."
    >
      <h2>1. General Principles</h2>
      <p>All refund and withdrawal requests are subject to verification, fraud review, and compliance checks.</p>

      <h2>2. Subscription Fees</h2>
      <p>Subscription fees are non-refundable unless otherwise approved in writing by the Company.</p>

      <h2>3. Advertising Spend</h2>
      <p>Funds actually spent on advertising platforms are non-refundable. This includes:</p>
      <ul>
        <li>Meta</li>
        <li>Google</li>
        <li>TikTok</li>
        <li>Snapchat</li>
        <li>Bing</li>
        <li>Taboola</li>
        <li>Outbrain</li>
        <li>MediaGo</li>
        <li>Any other advertising platform</li>
      </ul>

      <h2>4. Wallet Balances</h2>
      <p>Users may request withdrawal of available wallet balances. Withdrawals may be subject to:</p>
      <ul>
        <li>Identity verification</li>
        <li>Source-of-funds verification</li>
        <li>Fraud review</li>
        <li>Compliance review</li>
      </ul>
      <p>
        Where an account is terminated, wallet balances are returned in accordance
        with Section 11 of the{" "}
        <a href="/terms-of-service">Terms of Service</a>.
      </p>

      <h2>5. Processing Times</h2>
      <p>Withdrawals are typically processed within 1–10 business days. Processing times may vary based on:</p>
      <ul>
        <li>Payment method</li>
        <li>Banking system delays</li>
        <li>Platform reconciliation</li>
        <li>Compliance reviews</li>
      </ul>

      <h2>6. Payment Fees</h2>
      <p>Users are responsible for:</p>
      <ul>
        <li>Bank fees</li>
        <li>Wire fees</li>
        <li>FX conversion fees</li>
        <li>Intermediary bank fees</li>
        <li>Payment processor fees</li>
      </ul>
      <p>Such fees may be deducted from withdrawal amounts.</p>

      <h2>7. Chargebacks</h2>
      <p>If a chargeback or payment dispute is initiated:</p>
      <ul>
        <li>Wallet balances may be frozen</li>
        <li>Advertising accounts may be suspended</li>
        <li>Services may be terminated</li>
      </ul>
      <p>The Company reserves all rights to recover outstanding amounts.</p>

      <h2>8. Fraud Prevention</h2>
      <p>
        The Company may reject, delay, or cancel withdrawals where fraud, abuse,
        money-laundering concerns, or unauthorized payment activity are suspected.
      </p>

      <h2>9. Final Decisions</h2>
      <p>
        Refund and withdrawal decisions made in accordance with this Policy are final
        unless otherwise required by law.
      </p>

      <h2>10. Contact</h2>
      <p>
        For refund or withdrawal questions, email{" "}
        <a href="mailto:help@dannyclans.com">help@dannyclans.com</a>.
      </p>
    </LegalLayout>
  );
}
